import styled, { css } from 'styled-components';

import logo from '~/assets/icons/logo.png';

const StyledLogo = styled.div<{ $format: 'horizontal' | 'vertical' }>`
	position: absolute;
	width: 50px;
	height: 50px;
	opacity: 0.25;
	background-image: url(${logo});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;

	${(props) =>
		props.$format === 'horizontal'
			? css`
					&.UP_RIGHT {
						top: 100px;
						right: 100px;
					}

					&.UP_LEFT {
						top: 100px;
						left: 100px;
					}

					&.DOWN_RIGHT {
						bottom: 100px;
						right: 100px;
					}

					&.DOWN_LEFT {
						left: 100px;
						bottom: 100px;
					}
			  `
			: css`
					&.UP {
						top: 100px;
						left: 50%;
						transform: translateX(-50%);
					}

					&.DOWN {
						bottom: 100px;
						left: 50%;
						transform: translateX(-50%);
					}
			  `}
`;

export { StyledLogo };
